// extracted by mini-css-extract-plugin
export var chatHtmlText = "_ov-2";
export var chatLink = "_ov-0";
export var chatText = "_ov-1";